__turbopack_context__.v({
  "card": "ParagraphLightFeatures2x2-module__fmvatW__card",
  "cardBadge": "ParagraphLightFeatures2x2-module__fmvatW__cardBadge",
  "cardBody": "ParagraphLightFeatures2x2-module__fmvatW__cardBody",
  "cardDesc": "ParagraphLightFeatures2x2-module__fmvatW__cardDesc",
  "cardHeader": "ParagraphLightFeatures2x2-module__fmvatW__cardHeader",
  "cardIcon": "ParagraphLightFeatures2x2-module__fmvatW__cardIcon",
  "cardTitle": "ParagraphLightFeatures2x2-module__fmvatW__cardTitle",
  "cards": "ParagraphLightFeatures2x2-module__fmvatW__cards",
  "header": "ParagraphLightFeatures2x2-module__fmvatW__header",
  "heroText": "ParagraphLightFeatures2x2-module__fmvatW__heroText",
  "lead": "ParagraphLightFeatures2x2-module__fmvatW__lead",
  "section": "ParagraphLightFeatures2x2-module__fmvatW__section",
  "title": "ParagraphLightFeatures2x2-module__fmvatW__title",
});
